import React from "react"

import { arrayWithContents } from "../../../../utils"
import SeriesLineLayer from "./SeriesLineLayer"
import PointLayer from "../../GraphSVGLayers/PointLayer"

export default function SeriesLayer({ style, data, x, y, colour, pointSize, pointModifier, strokeWidth }) {
  const sharedProps = { data: data, colour: colour }
  const pointProps = {
    ...sharedProps,
    getXValue: (obs) => x(obs),
    getYValue: (obs) => y(obs),
    pointSize: pointSize,
    pointModifier: pointModifier,
  }
  const lineProps = {
    ...sharedProps,
    x: x,
    y: y,
    strokeWidth: strokeWidth,
  }
  if (style === "line" && arrayWithContents(data) && data.length > 1) {
    return <SeriesLineLayer {...lineProps} />
  } else if (style === "linespoints") {
    return (
      <>
        <SeriesLineLayer {...lineProps} />
        <PointLayer {...pointProps} />
      </>
    )
  } else {
    return <PointLayer {...pointProps} />
  }
}
